import styled from 'styled-components'


export const Animate = styled.div`
  ${props => props.animateOpacity && `
    opacity: ${props.isVisible ? 1 : 0};
  `}
  transition: all 1.25s;
`
